module.exports = __webpack_public_path__ + "ddb30bf10df05db644d2760f12eaec66.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/sphere.png
// module id = 550
// module chunks = 0